import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VerificationCustomerRoutingModule } from './verification-customer-routing.module';
import { VerificationCustomerCardComponent } from './verification-customer-card/verification-customer-card.component';
import { VerificationCustomerInfoComponent } from './verification-customer-info/verification-customer-info.component';
import { SharedModule } from '@shared/shared.module';
import { MatCoreModule } from '@shared/material/mat-core.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { VerificationCustomerComponent } from './verification-customer.component';

@NgModule({
  declarations: [
    VerificationCustomerCardComponent,
    VerificationCustomerInfoComponent,
    VerificationCustomerComponent
  ],
  imports: [
    VerificationCustomerRoutingModule,
    CommonModule,
    SharedModule,
    MatCoreModule,
    MatDatepickerModule,
    MatSelectModule,
    MatSnackBarModule  ]
})
export class VerificationCustomerModule { }
